export default __webpack_public_path__ + "static/img-app-training-641344ec32632dc44e77ef8244f7b8ab.jpg";